import { useSelector } from "react-redux";
import Main from "../../../presentational/common/Main";
import { getLoadingDataOnPageLoad } from "../../../../state/selectors";

const MainContainer = props => {
  const loadingDataOnPageLoad = useSelector(getLoadingDataOnPageLoad);

  return <Main {...{ ...props, loadingDataOnPageLoad }} />;
};

export default MainContainer;
